import { ReactElement, memo } from 'react';
import { Stack } from '@mui/material';

import {
  classes,
  DescriptionWithIconBoxText,
} from '../DescriptionWithIconBox/styles';

import { ScheduleRouteNameInfoProps } from './types';

const ScheduleRouteNameInfo = ({
  name,
  code,
}: ScheduleRouteNameInfoProps): ReactElement => (
  <Stack spacing={0.75}>
    <DescriptionWithIconBoxText
      variant="body2"
      className={classes.descriptionText}
    >
      {name}
    </DescriptionWithIconBoxText>

    <DescriptionWithIconBoxText
      className={classes.descriptionText}
      sx={{ fontSize: 12 }}
      fontWeight="bold"
      color="text.secondary"
    >
      {`#${code}`}
    </DescriptionWithIconBoxText>
  </Stack>
);

export default memo(ScheduleRouteNameInfo);
